import React from "react";
import { Navigate } from "react-router-dom";
import { usePermission } from "./PermissionContext";

export const ProtectedComponent: React.FC<{
  Component: React.FC<any>;
  path: any;
}> = ({ Component, ...rest }) => {
  const { isAdmin } = usePermission();
  return isAdmin ? <Component {...rest} /> : <Navigate to="/" />;
};

export default ProtectedComponent;
